import React from 'react';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Checkbox from '@mui/material/Checkbox';
import Typography from '@mui/material/Typography';
import '../../../Static/Master/firmtable.css';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { useDispatch, useSelector } from 'react-redux';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import { format_date } from '../../../Utils/Dateutils';
import { deletePaymentData } from '../../../Store/PHPSlice/Payment/paymentApi';


const TableBody = ({
    id,
    dt,
    payMemo,
    empId,
    empNm,
    fdt,
    tdt,
    payableamt,
    pay_mode,
    bnk_nm,
    chq_no,
    nar,
    paidamt,
    balamt,
    serialNumber,
    selected,
    handleClick,
}) => {
    const dispatch = useDispatch();
    // const getDelete = useSelector((state) => state.companyData.deleteComp);

    const handleDeleteClick = () => {
        // Show confirmation dialog
        const isConfirmed = window.confirm("you want to delete this Record?");

        // If user confirms, proceed with deletion
        if (isConfirmed) {
            dispatch(deletePaymentData(id))
                .then(() => {
                    // Reload the page to show updated results
                    // toast("Rack Deleted Sucessfully");
                    alert("Record Deleted");
                    window.location.reload();
                })
                .catch((error) => {
                    // Handle any errors that occur during the deletion process
                    console.error("Error deleting company:", error);
                    toast.error("Failed to delete company");
                });
        }
    };

    return (
        <>
            <TableRow hover tabIndex={-1} role="checkbox" selected={selected}>
                {/* <TableCell padding="checkbox">
                    <Checkbox disableRipple checked={selected} onChange={handleClick} />
                </TableCell> */}
                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{serialNumber}</TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>{format_date(dt)}</TableCell>
                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{payMemo}</TableCell>
                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>{`${format_date(fdt)} to ${format_date(tdt)}`}</TableCell>
                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{empNm}</TableCell>
                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{payableamt}</TableCell>
                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{paidamt}</TableCell>
                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{balamt}</TableCell>
                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{pay_mode}</TableCell>
                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{bnk_nm}</TableCell>
                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{chq_no}</TableCell>
                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>{nar}</TableCell>

                {/* <TableCell sx={{ p: 1 ,border: '1px solid #000'}} align='center'>
                    <EditIcon className="cursor-pointer" onClick={handleEditClick} />
                </TableCell> */}
                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    <DeleteIcon className="cursor-pointer" onClick={handleDeleteClick} />
                </TableCell>
            </TableRow>
            <ToastContainer />
        </>
    );
};

export default TableBody;
